import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Select,
  Row,
  Col,
  Input,
  message,
  Spin,
} from "antd";
import { CustomInput, CustomPasswordInput } from "../../components/customInput";
import { green } from "../../constants/colors";
import axios from "axios";
import { baseUrl } from "../../utills";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa6";
import { FaPhone } from "react-icons/fa";
// import GoogleLoginButton from "./googleLoginButton";
import logo from "../../assets/images/msm-motors-black-logo.png";
import OtpInput from "./otpInput";
const ForgotForm = ({ setOpenModal3, setOpenModal2 }) => {
  const [loading, setLoading] = useState(false);
  const [state, setState]=useState(true);
  const [email, setEmail]=useState();
  const navigate = useNavigate();
  const { Option } = Select;
  const [formLayout, setFormLayout] = useState("vertical");
  const [messageApi, contextHolder] = message.useMessage();
  const [form2] = Form.useForm();

  const formItemLayout =
    formLayout === "horizontal"
      ? {
          labelCol: {
            span: 4,
          },
          wrapperCol: {
            span: 14,
          },
        }
      : null;
  const buttonItemLayout =
    formLayout === "horizontal"
      ? {
          wrapperCol: {
            span: 14,
            offset: 4,
          },
        }
      : null;

  
  const forgotPassword = async (values) => {
    setLoading(true);
    try {
      const res = await axios.post(baseUrl + "forgot-password/",values);
      // console.log("signin", res);
      if (res?.status === 200) {
        setLoading(false);
        console.log("forgot res", res);
        setEmail(values.email);
        setState(false)
        messageApi.open({
          type: "success",
          content: res?.data?.detail,
        });
        // if (res?.data?.user?.role == "admin") {
        //   navigate("/admin-layout");
        // } else {
        //   navigate("/layout");
        // }
      }
    } catch (error) {
      setLoading(false);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.detail,
      });

      console.error("error....", error);
    }
  };
  
  return (
    <div className="w-[95%] sm:w-[80%] md:w-[80%] lg:w-[50%] xl:w-[30%] m-auto pt-6 pb-20 bg-white rounded rounded-[10px] px-8 border border-gray-300">
      {contextHolder}
      <Spin spinning={loading} className="custom-spin">
        <Form
          {...formItemLayout}
          layout={formLayout}
          form={form2}
          name="form2"
          onFinish={forgotPassword}
          initialValues={{
            layout: formLayout,
          }}
        >
            {state?
          (
            <>
            <div className="border-b border-gray-300 mb-6">
            <p className="text-[22px] text-center font-[700] ms-2 mb-4">
              Forgot Password
            </p>
           
          </div>

          <Row gutter={[23, 0]}>
            <Col xs={24}>
              <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>Email</p>
                }
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please! enter your email address",
                  },
                ]}
              >
                <CustomInput placeholder="Enter your email address" />
              </Form.Item>
            </Col>
           
          </Row>
            
          
          
          <Form.Item
           
            {...buttonItemLayout}
          >
            <Button
              size="large"
              style={{
                marginTop: "10px",
                backgroundColor: green,
                borderColor: green,
                color: "black",
                borderRadius: "5px",
                width: "100%",
                //   marginLeft: "10px",
                height: "48px",
                fontWeight: 500,
              }}
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
          </>
          )

:
(
   <>
    <div className="border-b border-gray-300 mb-6">
   <p className="text-[22px] text-center font-[700] ms-2 mb-4">
     Enter OTP
   </p>
  
 </div>

<OtpInput email={email}/>
   </>
)
 }
       
          {/* <GoogleLoginButton /> */}
          {/* <Button
            size="large"
            style={{
              marginTop: "10px",
              backgroundColor: "transparent",
              borderColor: green,
              color: "black",
              borderRadius: "5px",
              width: "100%",
              height: "48px",
              fontWeight: 500,
              position: "relative",
            }}
            type="primary"
          >
            <FaFacebook
              style={{
                fontSize: "24px",
                position: "absolute",
                left: "20%",
                top: "50%",
                transform: "translate(-20%, -50%)",
                color: "blue",
              }}
            />{" "}
            Continue with Facebook
          </Button>
          <Button
            size="large"
            style={{
              marginTop: "10px",
              backgroundColor: "transparent",
              borderColor: green,
              color: "black",
              borderRadius: "5px",
              width: "100%",
              height: "48px",
              fontWeight: 500,
              position: "relative",
            }}
            type="primary"
          >
            <FaPhone
              style={{
                fontSize: "24px",
                position: "absolute",
                left: "20%",
                top: "50%",
                transform: "translate(-20%, -50%)",
                color: "gray",
              }}
            />{" "}
            Continue with Phone
          </Button> */}
        </Form>
      </Spin>
    </div>
  );
};

export default ForgotForm;
